module.exports = __webpack_public_path__ + "media/src/img/payment/yam-59e3093795773cbecf1d1b33aaab734b.png";